"use strict";
import Vue      from 'vue/dist/vue.common.js';
import Velocity from 'velocity-animate';

const SubNav = Vue.component('ts-sub-nav', {
  template: `
    <transition
    :css="false"
    @enter="tEnter"
    @enter-cancelled="tCancelled"
    @leave="tLeave"
    @leave-cancelled="tCancelled">
      <ul :id="id"
      class="GlobalNavigation-subnav"
      v-if="active"
      aria-live="polite"
      aria-relevant="all"
      aria-atomic="false">
        <slot></slot>
      </ul>
    </transition>
  `,

  data()  {
    return {
      duration: 300
    };
  },

  props: {
    active: {
      default: false,
      required: false,
      type: Boolean
    },
    id: {
      required: true,
      type: String
    }
  },

  methods: {

    tEnter(el, done) {
      Velocity(el, 'slideDown', {
        duration: this.tDurations,
        complete: ()=> {
          el.style.display = 'block';
          return done;
        }
      });
    },

    tLeave(el, done) {
      Velocity(el, 'slideUp', {
        duration: this.tDurations,
        complete: ()=> {
          el.style.display = 'none';
          return done;
        }
      });
    },

    tCancelled(el) {
      Velocity(el, 'stop');
    }
  }
});

export default SubNav;